import { Badge, Flex } from '@chakra-ui/react';

interface IndicatorBadgeProps {
  text: string;
}

export const Indicator = ({ text }: IndicatorBadgeProps) => {
  const outerFlex = {
    align: 'center',
  };

  const badgeStyle = {
    backgroundColor: 'brand.light-green',
    color: 'brand.army-green',
    letterSpacing: '0.06em',
    padding: '4px 12px 4px 12px',
    borderRadius: '8px',
  };

  return (
    <Badge sx={badgeStyle}>
      <Flex sx={outerFlex}>{text}</Flex>
    </Badge>
  );
};
